import { isNative } from '../../../lib/platform'
import { attributedUrl, captureAttribution, readAttribution, saveAttribution } from '../lib/attribution'

type Goal = 'quiz_start' | 'quiz_complete' | 'path_view' | 'chat_open' | 'chat_message_sent' | 'sos_click' | 'paywall_view' | 'tasks_view' | 'home_view' | 'onboarding_start' | 'onboarding_step_view' | 'onboarding_complete' | 'payment_open'
let screen: string | undefined

export function isBreakupAnalytics(): boolean {
  return !isNative && window.METRIKA_CONFIG?.product === 'break_up'
}

function send(method: string, ...args: unknown[]): boolean {
  const counter = window.METRIKA_CONFIG?.counterId
  if (!isBreakupAnalytics() || !counter || !window.ym) return false
  try { window.ym(counter, method, ...args); return true } catch { return false }
}

interface GoalParams {
  onboarding_variant?: 'quiz' | 'no_quiz'
  onboarding_step?: 1 | 2 | 3
  tariff?: 'week' | 'month' | 'program'
}

function goal(name: Goal, params: GoalParams = {}): boolean {
  if (!isBreakupAnalytics()) return false
  open()
  const context = readAttribution()
  if (name === 'quiz_complete') context.quiz_completed = true
  saveAttribution(context)
  return send('reachGoal', name, { entry_point: context.entry_point, quiz_completed: context.quiz_completed, ...params })
}

function open(): void {
  if (!isBreakupAnalytics()) return
  const context = captureAttribution()
  if (!context.pwa_opened && send('reachGoal', 'pwa_open', {
    entry_point: context.entry_point, quiz_completed: context.quiz_completed,
  })) {
    context.pwa_opened = true
    saveAttribution(context)
  }
}

export const breakupAnalytics = {
  goal,
  captureEntry() { if (isBreakupAnalytics()) captureAttribution() },
  open,
  screen(path: string): boolean {
    if (!isBreakupAnalytics() || path === screen) return false
    this.open()
    if (!send('hit', attributedUrl(path), { title: 'BreakUp', referer: screen ? attributedUrl(screen) : undefined })) return false
    screen = path
    return true
  },
}
